import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import rootReducer from '../reducers/rootReducer';
const reduxLoggerMiddleware = createLogger();

export default function configureStore(preloadedState) {
  const middlewares = [];
  middlewares.push(thunkMiddleware);

  // Note: always add reduxLogger at end.
  if (process.env.NODE_ENV === 'development') {
    middlewares.push(reduxLoggerMiddleware);
  }

  const store = createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middlewares)
  );
  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js